import { gql } from "@apollo/client"
import { TAG_FIELDS } from "../../tags/useQueryTags"

import {
  BOOLEAN_CUSTOM_FIELD_FRAGMENT,
  DATE_CUSTOM_FIELD_FRAGMENT,
  NUMBER_CUSTOM_FIELD_FRAGMENT,
  STRING_CUSTOM_FIELD_FRAGMENT
} from "../../customFields/fragments/customFieldsFragment"

const ASSET_FIELDS = gql`
  ${BOOLEAN_CUSTOM_FIELD_FRAGMENT}
  ${DATE_CUSTOM_FIELD_FRAGMENT}
  ${NUMBER_CUSTOM_FIELD_FRAGMENT}
  ${STRING_CUSTOM_FIELD_FRAGMENT}
  fragment AssetFields on Asset {
    id
    name
    locations {
      id
      name
    }
    groups {
      id
      name
    }
    tags {
      ...TagFields
    }
    suppliers {
      supplier {
        id
        name
      }
    }
    uploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    actions {
      id
      title
      priority
      status
      author {
        fullName
      }
      dueAt
    }
    assetType {
      id
      name
    }
    customFieldValues {
      ... on BooleanCustomFieldValue {
        id
        customField {
          ...BooleanCustomFieldFields
          ...DateCustomFieldFields
          ...NumberCustomFieldFields
          ...StringCustomFieldFields
        }
        boolean: value
      }
      ... on StringCustomFieldValue {
        id
        customField {
          ...BooleanCustomFieldFields
          ...DateCustomFieldFields
          ...NumberCustomFieldFields
          ...StringCustomFieldFields
        }
        string: value
      }
      ... on NumberCustomFieldValue {
        id
        customField {
          ...BooleanCustomFieldFields
          ...DateCustomFieldFields
          ...NumberCustomFieldFields
          ...StringCustomFieldFields
        }
        number: value
      }
    }
    notes {
      id
      text
      author {
        id
        fullName
        firstName
        lastName
        avatar {
          key
        }
      }
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      createdAt
    }
  }
  ${TAG_FIELDS}
`

export { ASSET_FIELDS }
